/**
 * Google AdSense configuration.
 *
 * HOW TO CONNECT YOUR AD UNITS (2 minutes):
 *
 * 1. Go to https://www.google.com/adsense/ → Anúncios → Por bloco de anúncios
 * 2. Click "Criar novo bloco de anúncios" → choose "Anúncios apresentados no artigo"
 *    (or "In-article ads") for the three article slots below.
 * 3. Give it a name (e.g. "CIT Article Top"). AdSense will show you a code snippet
 *    that includes `data-ad-slot="1234567890"`.
 * 4. Copy ONLY the number (e.g. "1234567890") and paste it below between the quotes.
 * 5. Repeat for the mid, bottom and blog-index slots.
 * 6. Save and redeploy.
 *
 * That's it. The website already loads the AdSense library — these slots just
 * tell Google WHERE to place the ads on each page.
 *
 * Leave a slot empty ("") to hide it on the site until you configure it.
 */

// Your publisher ID — already set from your AdSense account.
export const ADSENSE_CLIENT = "ca-pub-7682818267355685";

// Ad unit slot IDs. Paste the number Google gives you in each ad unit.
export const AD_SLOTS = {
  // Appears near the top of every blog article (after the intro paragraph).
  articleTop: "",

  // Appears in the middle of every blog article (between sections).
  articleMid: "",

  // Appears at the bottom of every blog article (before the "Read next" section).
  articleBottom: "",

  // Appears on the blog index page between the featured post and the article grid.
  blogIndex: "",
};

// Convenience helper — returns true when a slot has been configured.
export const hasAdSlot = (slotName) => Boolean(AD_SLOTS[slotName]);
